export const DEFAULT_MASK = '+7 (***) ***-**-**';
export const NUMBER_SYMBOL = '*';
export const DATA_TEST_ID = 'phoneInput';

export const COUNTRY_CODE = '7';
export const INVALID_CODES = [/^88/, /^89/, /^7/];

export const defaultHandler = () => {};
